import styled from 'styled-components';

/**
 * The design's `.thumb`. One size at every depth and on every table — the
 * 40px circle that shrank to 32px for a child row said "two kinds of thing"
 * where the indent already said "one thing, one level down".
 */
export const Thumb = styled.div`
  display: grid;
  place-items: center;
  flex: 0 0 var(--h-thumb);
  width: var(--h-thumb);
  height: var(--h-thumb);
  overflow: hidden;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  font-family: var(--font-ui);
  font-size: var(--fs-label);
  font-weight: var(--fw-semibold);
  line-height: 1;
  background: var(--surface-alt);
  color: var(--text-muted);

  /* An icon child. Sized here so a call site passes bare path data. */
  > svg {
    width: 16px;
    height: 16px;
    stroke-width: 1.7;
  }

  /* The three menu grounds from the design file. */
  &.food {
    background: var(--warn-soft);
    color: var(--warn);
  }

  &.cold {
    background: var(--info-soft);
    color: var(--info);
  }

  &.hot {
    background: var(--danger-soft);
    color: var(--danger);
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
